import { FC } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { useParams } from 'react-router';

import { useDeletePlanOnMapModalStore } from './DeletePlanOnMapStore';

import { deleteInteractiveMapPlan } from 'api/InteractiveMap/deleteInteractiveMapPlan';

interface DeletePlanOnMapModalProps {
  refetchTraps: () => void;
}

const DeletePlanOnMapModal: FC<DeletePlanOnMapModalProps> = ({ refetchTraps }) => {
  const { t } = useTranslation();
  const { isOpen, onDeleteVulClose, planSlug } = useDeletePlanOnMapModalStore();
  const { slug } = useParams();

  const onSubmit = async () => {
    if (!planSlug || !slug) return;

    const payload = {
      site_slug: slug as string,
      slug: planSlug as string,
    };

    try {
      await deleteInteractiveMapPlan(payload);

      enqueueSnackbar(t('MapModals.deletePlanOnMapModal.deletePlan'));
      onDeleteVulClose();

      window.location.reload();
    } catch (error: any) {
      if (error?.response?.data?.name) {
      } else {
        enqueueSnackbar(t('MapModals.deletePlanOnMapModal.error'));
      }
    }
  };
  return (
    <div>
      <Modal isOpen={isOpen} size="md">
        <ModalHeader className="border-bottom pb-3 pt-3 ">
          <p className="text-purple m-0">{t('Modals.delete-modal.title')}</p>
        </ModalHeader>
        <ModalBody>
          <div className="row mb-2 ">
            <div className="col-xl-12 text-center">
              <p>{t('Modals.delete-modal.msg-delete-site-plan', { name: planSlug })}</p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="w-100 d-flex justify-content-end ">
            <Button
              className="btn btn-ghost-danger"
              onClick={() => {
                onDeleteVulClose();
              }}
            >
              {t('Modals.delete-modal.cancel')}
            </Button>

            <Button
              className="btn btn-ghost-success"
              onClick={() => {
                onSubmit();
                onDeleteVulClose();
                refetchTraps();
              }}
            >
              {t('TrapModals.confirm')}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DeletePlanOnMapModal;
